// How It Works section content
export const howItWorks = {
  headline: 'How SlideFactory Works',
  lead: 'From configuration to delivery in four simple steps. Our automation handles the complexity so you can focus on your content and strategy.',

  steps: [
    {
      number: 'Step 1',
      icon: '⚙',
      title: 'Configure',
      items: [
        { text: 'AI provider', bold: true },
        { text: 'template', bold: true },
        { text: 'output format', bold: true },
        { text: 'data sources', bold: true }
      ],
      labels: ['Select', 'Choose', 'Define', 'Connect'],
      primary: false
    },
    {
      number: 'Step 2',
      icon: '📄',
      title: 'Input',
      items: [
        { text: 'topic or prompt', bold: true },
        { text: 'documents', bold: true },
        { text: 'brand assets', bold: true },
        { text: 'requirements', bold: true }
      ],
      labels: ['Provide', 'Upload', 'Include', 'Specify'],
      primary: false
    },
    {
      number: 'Step 3',
      icon: '🤖',
      title: 'Generate',
      items: [
        { text: 'AI processes', bold: true },
        { text: 'RAG retrieves', bold: true },
        { text: 'Template applies', bold: true },
        { text: 'Quality check', bold: true }
      ],
      labels: ['', '', '', ''],
      suffixes: ['content', 'context', 'formatting', 'runs'],
      primary: false
    },
    {
      number: 'Step 4',
      icon: '🎯',
      title: 'Deliver',
      items: [
        { text: 'Download', bold: true },
        { text: 'Webhook', bold: true },
        { text: 'Storage', bold: true },
        { text: 'Workflow', bold: true }
      ],
      labels: ['', '', '', ''],
      suffixes: ['PPTX', 'fires', 'uploads', 'continues'],
      primary: true
    }
  ]
}
